import FileViewer from 'react-file-viewer';
import React from "react";
import { CustomErrorComponent } from 'custom-error';
import file from "../../image/temp/yishif.docx";
const type = 'docx'
class Privacypolicy extends React.Component {
    constructor(props) {
        super(props);
        console.log(file)
    }
    render() {
        return (
            <div>
                <FileViewer
                    fileType={type}
                    filePath={file}
                    errorComponent={CustomErrorComponent}
                    onError={this.onError}/>
            </div>
        );
    }

}
export default Privacypolicy;